import {
  BreadcrumbSeperator,
  BreadcrumbTitle,
} from "@/components/Breadcrumbs/Breadcrumbs";
import { ProfileButton } from "@/components/ProfileButton/ProfileButton";
import { getCurrentContactEntity } from "@/models/contact";
import { Group } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import { useAtomValue } from "jotai";

export const Header = () => {
  const entity = getCurrentContactEntity();
  const { data: contact } = useAtomValue(entity.getObserveEntityRecordAtom());
  const contactName = contact?.name || "(Untitled Contact)";

  useDocumentTitle(`ETA IQ - Contact (${contactName})`);

  return (
    <Group px={"xs"} h={"100%"} w={"100%"} align="center" gap={6}>
      <BreadcrumbTitle>Contact</BreadcrumbTitle>
      <BreadcrumbSeperator />
      <BreadcrumbTitle>{contactName}</BreadcrumbTitle>

      <Group ml={"auto"} gap={"xs"}>
        <ProfileButton />
      </Group>
    </Group>
  );
};
